import React from "react";

function Tittle({ text }) {
  return (
    <div className="class">
      <div className="class-con">
        <h1>{text}</h1>
      </div>
    </div>
  );
}

export default Tittle;
